import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";


import gl from '@/api/global';

//element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css';
Vue.use(ElementUI);

//公共css
import "./assets/css/common.less"
//iconfont图标css
import "./assets/iconfont/iconfont.css";

Vue.config.productionTip = false;

import tips from "@/components/modal/tips";
Vue.prototype.$tips = tips;

import mess from "@/components/modal/message";
Vue.prototype.$mess = mess;

import custom from "@/components/modal/custom";
Vue.prototype.$custom = custom;

import confirm from "@/components/modal/confirm/index.js";
Vue.prototype.$confirm = confirm;

import api from "@/api/api.js";
Vue.prototype.$api = api;
// 配置cookie
import cookies from 'vue-cookies'
Vue.prototype.$cookies = cookies;

import axios from "axios"
axios.interceptors.request.use(config => {
  // console.log(localStorage.getItem('token'))
  config.withCredentials = true // 允许携带token ,这个是解决跨域产生的相关问题
  if (cookies.get('sso_userId')) {
    let token = cookies.get('sso_token')
    let userId = cookies.get('sso_userId')
    config.headers = {
      'token': token,
      'userId': userId
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})
axios.interceptors.response.use((res) => {
  // console.log(res.data.code == 10)
  if (res.data.code == 401) {
    // store.commit('logout')
    window.location.href = gl.rzUrl;
  } else if (res.data.code == 402) {
    window.location.href = gl.rzUrl
  }
  return res.data;

}, (error) => {
  console.log(error);
  return Promise.reject(error)
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
